import { RootState } from "redux/rootReducer";

export const selectIsCompletingRequest = (state: RootState) =>
  state.completeRequest.loading;
export const selectCompleteRequestErrorMessage = (state: RootState) =>
  state.completeRequest.error;
export const completeRequestDataResponse = (state: RootState) =>
  state.completeRequest.completeRequestResponse;
